import { t } from "@/i18n-js/instance";
import { CheckList } from "@/react/components/CommunityOnboarding/NewChecklistComponents/CheckList";
import { CircleAppLinks } from "@/react/components/CommunityOnboarding/NewChecklistComponents/CircleAppLinks";
import { Resources } from "@/react/components/CommunityOnboarding/NewChecklistComponents/Resources";
import { usePunditUserContext } from "@/react/contexts";
import { Typography } from "@circle-react-uikit/Typography";
import { YourOverview } from "./YourOverview";

export const AdminDashboardPage = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const firstName = currentCommunityMember?.name;

  return (
    <div className="bg-primary h-full">
      <div className="mx-auto max-w-4xl px-6 py-8">
        <div className="mb-8">
          <Typography.TitleLg weight="bold">
            {t("admin_dashboard.greeting", { firstName })}
          </Typography.TitleLg>
        </div>
        <div className="space-y-8">
          <CheckList variant="compact" />
          <YourOverview />
          <Resources variant="admin-dashboard" />
          <CircleAppLinks />
        </div>
      </div>
    </div>
  );
};
